
import { Component, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormArray, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { debounceTime, delay, filter, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { ClientService, RoleModel } from '../client.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';
import { NGXLogger } from 'ngx-logger';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { ICountry } from 'src/app/masters/places/country/country.interface';

@Component({
    selector: 'app-client-add',
    templateUrl: './client-form.component.html',
    styleUrls: ['./client-form.component.less'],
    standalone: false
})
export class ClientFormComponent implements OnDestroy{

  countries = [];
  filteredCountries:ReplaySubject<ICountry[]> = new ReplaySubject<ICountry[]>(1);
  states = [];
  cities = [];
  searching = false;
  onDestroy = new Subject<void>();
  clientForm: FormGroup;
  gsaMode: 'view' | 'edit' = 'view';
  gsaIndex: number;
  gsaCol: any[] = [
    { id: 'name', name: 'Name' },
    { id: 'emailId', name: "Email id" },
    { id: 'contactNumber', name: "Contact Number" },
    { id: 'userRoles', name: "Role" },
    // { id: "$$edit", name: "$$edit" },
  ];
  gsaColumns: string[] = this.gsaCol.map(col => col.id);
  // gsaDataSource:BehaviorSubject<Gsa[]>= new BehaviorSubject([]);
  gsaDataSource = this.clientService.gsaList$;

  documentMode: 'view' | 'edit' = 'view';
  documentIndex: number;
  documentCol: any[] = [
    { id: 'documentCode', name: 'Document Code' },
    { id: 'documentName', name: "Document Name" },
    { id: 'uploadDocument', name: "Upload Document" },
    { id: "$$edit", name: "$$edit" }
  ];
  documentColumns: string[] = this.documentCol.map(col => col.id);
  documentDataSource = this.clientService.documentList$;
  countrySearchCtrl:FormControl = new FormControl();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredRole: Observable<RoleModel[]>;

  @ViewChild('roleInput') roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private clientService: ClientService, 
    private service: DataService,
    private activeRoute: ActivatedRoute,
    private logger: NGXLogger,
    private router: Router, 
    private formBuilder: FormBuilder) {
      this.logger.info('router ', this.router);
  }
  reactiveForm() {
    this.clientForm = this.formBuilder.group({
      code	: [],
      emailId: [],
      activeFlag: [false],
      address: this.getAddressForm(),
      id: [],
      mobileNo:[],
      name: [],
      panNo: [],
      reactivateDtls: [],
      salesTaxId: [],
      status: [],
      submittedForApproval	: [],
      clientCountryCtrl: [null],
      clientCountryFilteringCtrl: [null],
      gsaDetails: this.formBuilder.array([this.getGsaForm()]),
      documentControls: FormArray,
      roleControl: [null],
    })
    this.filteredRole = this.clientForm.controls["roleControl"].valueChanges.pipe(startWith(''),
      map(value => this.clientService.roleList)
    );
    this.controlGsa();
    this.controlDocument();
  }

  private getGsaForm(): FormGroup{
    return this.formBuilder.group({
      id: [null],
      name: [null],
      email: [null, [Validators.email]],
      contactNo: [null,[Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      userRoles: [null]
    });
  }
  private getAddressForm(): any {
    return this.formBuilder.group({
      address: [],
      cityId: [],
      countryId: [],
      id: [],
      landMarkSet: [],
      location: [],
      pincode: [],
      stateId: []
    });
  }

  ngOnInit() {
    this.reactiveForm();

    this.filterCountries();
    this.getCountryList();
    this.setCountryChangeEvent();

    this.processRouteValues();
  }
  private setCountryChangeEvent() {
    this.clientForm.get('address.countryId').valueChanges.subscribe(countryIdValue => {
      this.logger.info('countryIdValue changed ', countryIdValue);
      this.getStateList();
      this.getCityList();

    });
  }

  

  private processRouteValues() {
    this.activeRoute.params.subscribe(params => {
      this.clientForm.get('id').setValue(params['id']);
      this.logger.info('client id ', this.id);
      this.getClientData();
    });
  }

  getClientData(){
    if(!this.id){ return; }
    this.service.get(Api.CLIENT+APP_ROUTES.slash+this.id).subscribe(res => {
      if (res) {
        this.logger.info('client by id', res);
        this.clientForm.patchValue(res);
      }
    });
  }

  getCountryList(){
    let criteria = {
      'size':1000,
      'page': 0
    }
    this.service.get(Api.COUNTRY, criteria).subscribe(res => {
      if (res) {
        this.logger.info('country list', res);
        this.countries = res.contents;
        this.filteredCountries.next(this.countries);
      }
    });
  }

  countryChanged(){
    this.logger.info('countryId ', this.countryId);
    this.getStateList();
    this.getCityList();
  }
  private getStateList() {
    let criteria = {
      'size':1000,
      'page': 0
    }
    this.service.get(Api.STATE, criteria).subscribe(res => {
      if (res) {
        this.logger.info('state list', res);
        this.states = res.contents;
      }
    });
  }

  
  getCityList(){
    this.cities = [];
    this.logger.info('countryId ',this.countryId);
    let criteria = {
      'size':1000,
      'page': 0
    }
    if(!this.countryId){ return; }
    this.service.get(Api.CITIES_BY_COUNTRY_ID+this.countryId, criteria).subscribe(res => {
      if (res) {
        this.logger.info('city list', res);
        this.cities = res;
      }
    });
  }
  editGsa(index: number) {
    this.gsaIndex = index;
    this.gsaMode = 'edit';
    return false;
  }
  removeGsa(index: number) {
    this.clientService.removeGsa(index);
    this.controlGsa();
  }
  updateGsa(index: number) {
    if (this.gsaMode == 'edit') {
      this.gsaMode = 'view';
      this.gsaIndex = 0;
      let gsaValueList = Object.keys(this.clientService.gsaList$.value[index]);
      for (let prop in gsaValueList) {
        const control = this.getControlGsa(index, gsaValueList[prop]);
        if (control != null) {
          if (control.valid) {
            this.clientService.updateGsa(index, gsaValueList[prop], control.value);
          }
          if (control.invalid) {
            this.gsaMode = 'edit';
            this.gsaIndex = index + 1;
            break;
          }
        }
      }
    }
  }
  newGsa(eventKey, index: number) {
    this.logger.info('eventKey, number ', eventKey, index);
    if (eventKey.key == "Tab") {
      let status = 0;
      let gsaValueList = Object.keys(this.clientService.gsaList$.value[index]);
      for (let prop in gsaValueList) {
        const control = this.getControlGsa(index, gsaValueList[prop]);
        if (control != null) {
          if (control.invalid) {
            status = 1;
          }
        }
      }
      if (status == 0) {
        for (let prop in gsaValueList) {
          const control = this.getControlGsa(index, gsaValueList[prop]);
          if (control != null) {
            if (control.valid) {
              this.clientService.updateGsa(index, gsaValueList[prop], control.value);
            }
          }
        }
        this.clientService.addRowGsa(index + 1)
        this.controlGsa();
      }
    }
  }
  getControlGsa(index: number, fieldName: string) {
    var arrayControlGsa = this.clientForm.get('gsaDetails') as FormArray;
    return arrayControlGsa.at(index).get(fieldName) as FormControl;
  }
  getControlDocument(index, fieldName) {
    var arrayControlDocument = this.clientForm.get('documentControls') as FormArray;
    return arrayControlDocument.at(index).get(fieldName) as FormControl;
  }
  controlGsa() {
    const togroups = this.clientService.gsaList$.value.map(entity => {
      return new FormGroup({
        position: new FormControl(entity.position),
        name: new FormControl(entity.name, Validators.required),
        emailId: new FormControl(entity.email, Validators.required),
        contactNumber: new FormControl(entity.contactNo),
        role: new FormControl(entity.role),
      }, { updateOn: "blur" });
    });
    this.clientForm.controls.gsaDetails = new FormArray(togroups);
  }
  controlDocument() {
    const togroups = this.clientService.documentList$.value.map(entity => {
      return new FormGroup({
        position: new FormControl(entity.position, Validators.required),
        documentName: new FormControl(entity.documentName, Validators.required),
        uploadDocument: new FormControl(entity.uploadDocument),
        documentCode: new FormControl(entity.documentCode, Validators.required),
      }, { updateOn: "blur" });
    });
    this.clientForm.controls.documentControls = new FormArray(togroups);
  }
  editDocument(index: number) {
    this.documentIndex = index;
    this.documentMode = 'edit';
    return false;
  }
  newDocument(eventKey, index: number) {
    if (eventKey.key == "Tab") {
      let status = 0;
      let documentValueList = Object.keys(this.clientService.documentList$.value[index]);
      for (let prop in documentValueList) {
        const control = this.getControlDocument(index, documentValueList[prop]);
        if (control != null) {
          if (control.invalid) {
            status = 1;
          }
        }
      }
      if (status == 0) {
        for (let prop in documentValueList) {
          const control = this.getControlDocument(index, documentValueList[prop]);
          if (control != null) {
            if (control.valid) {
              this.clientService.updateDocument(index, documentValueList[prop], control.value);
            }
          }
        }
        this.clientService.addDocument(index + 1)
        this.controlDocument();
      }
    }
  }
  removeDocument(index: number) {
    this.clientService.removeDocument(index);
    this.controlDocument();
  }
  updateDocument(index: number) {
    if (this.documentMode == 'edit') {
      this.documentMode = 'view';
      this.documentIndex = 0;
      let documentValueList = Object.keys(this.clientService.documentList$.value[index]);
      for (let prop in documentValueList) {
        const control = this.getControlDocument(index, documentValueList[prop]);
        if (control != null) {
          if (control.valid) {
            this.clientService.updateDocument(index, documentValueList[prop], control.value);
          }
          if (control.invalid) {
            this.documentMode = 'edit';
            this.documentIndex = index + 1;
            break;
          }
        }
      }
    }
  }

  removeRole(gsaIndex: number, roleIndex: number): void {
    this.clientService.removeRole(gsaIndex, roleIndex);
    this.controlGsa();
  }

  addRole(event: MatAutocompleteSelectedEvent, roleIndex: number): void {
    this.clientService.addNewRole(roleIndex, event.option.viewValue)
  }
  
  onCancel() {
    this.router.navigate(['masters/operational/client']);
  }
  onSave() {
    this.logger.info('client form', this.clientForm.value);
    this.logger.info('gsaDetails ',this.gsaDetails);
    this.logger.info('gsaDataSource ', this.gsaDataSource);
    let clientData = this.clientForm.value;
    clientData.gsaDetails = this.gsaDetails;
    clientData.gsaDetails.splice(-1,1);
    // delete clientData.
    this.logger.info('Final client data ', clientData);
    this.service.post(Api.CLIENT, clientData).subscribe(res => {
        this.logger.info('client save response', res);
        this.router.navigate(['masters/operational/client']);
    });
    //this.router.navigate(['masters/operational/client']);
  }
  filterCountries() {
    this.logger.info('Request to filter countries');
    this.countrySearchCtrl.valueChanges.pipe(
      // filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          this.logger.info('searching country ', search);
          if (!this.countries) { return []; }
          if(!search) { this.filteredCountries.next(this.countries); }
          return this.countries.filter(country => country.name.toLowerCase().indexOf(search) > -1);
        }),
        delay(500)
      )
      .subscribe(filteredClient => {
        this.searching = false;
        this.filteredCountries.next(filteredClient);
      },
      error => { this.searching = false; });
  }
  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  
  }

  get id(){ return this.clientForm.get('id')?.value; }
  get countryId(){ return this.clientForm.get('address')?.get('countryId')?.value; }
  get gsaDetails() { return (this.clientForm.get('gsaDetails') as FormArray).value; }
}









